/**
 * Documented defaults for every numeric constant in the brief (§3) that is NOT
 * one of the ten per-level difficulty params. Anything in the sim that is a
 * number must come from here or from the board JSON `params` block.
 */
export const DEFAULTS = {
  /** Game tick in ms (12.5 Hz). Used by the app loop, not the sim. */
  tickMs: 80,
  /** Field size (portrait). */
  fieldWidth: 10,
  fieldHeight: 15,
  /** Player moves 1 cell per N ticks (brief: 5 horizontal, 6 vertical). */
  playerTicksPerCellH: 5,
  playerTicksPerCellV: 6,
  /** Gem score and octave rules. */
  gemPoints: 25,
  octaveLength: 8,
  octavePoints: 250,
  chainTicks: 9,
  /** Sacks. */
  sackWobbleTicks: 15,
  sackFallTicksPerCell: 2,
  /** A sack falling MORE than this many rows breaks into gold. */
  sackBreakRows: 1,
  /**
   * Brief v2 §3 rule change: a sack about to land on the player from more than one row holds
   * this many ticks first ("sack shadow" warning). Board param `sackShadowTicks` overrides; 0 = off.
   */
  sackShadowTicks: 2,
  goldPoints: 500,
  crushKillPoints: 250,
  /** Flame. */
  flameKillPoints: 250,
  flameTicksPerCell: 1,
  /** Lantern economy (Systems Brief §2.1, approved numbers): gems per shot, banked charges per Beam, charge cap, default starting charges. */
  lanternGemsPerShot: 8,
  lanternChargesPerBeam: 5,
  lanternMaxCharges: 5,
  lanternStartCharges: 1,
  lanternGemsPerCharge: 4,
  /** Beam: render ticks, and pillars take two beams whatever their flame hits. */
  beamTicks: 4,
  beamPillarHits: 2,
  /** Kit durations in ticks: shield 20 s max, turbo 8 s. Turbo halves ticks per cell. */
  shieldTicks: 250,
  turboTicks: 100,
  turboSpeedFactor: 2,
  /** Bonus mode. */
  bonusItemPoints: 1000,
  bonusEatBasePoints: 200,
  /** Lives. */
  startingLives: 3,
  extraLifeEvery: 20000,
  maxSpareLives: 4,
  invincibilityTicks: 50,
  /** Creature AI. */
  turnPenaltyTicks: 1,
  /** Brief v2 §3 rule change: Crawlers blocked by dirt also gain frustration. Board param `frustrationCountsDirt` overrides. */
  frustrationCountsDirt: true,
  /** Contact radius between player and creature, in cells (interpolated positions). */
  contactDistance: 0.5,
  /** Timers for non-play phases. */
  deathTicks: 20,
  /** Any input after this many ticks of the death pause skips the rest (one-tap restart). */
  deathSkipAfterTicks: 5,
  levelClearTicks: 25,
  /** Gauntlet length. */
  gauntletSeconds: 90,
} as const;

export const GAUNTLET_TICKS = Math.round((DEFAULTS.gauntletSeconds * 1000) / DEFAULTS.tickMs);
